/*
 * @Descripttion:
 * @version:
 * @Author: 陈宇鹏
 * @Date: 2021-07-19 14:08:41
 * @LastEditors: 陈宇鹏
 * @LastEditTime: 2021-07-21 11:48:43
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import index from './modules/index/index'
import receivingOrder from './modules/receivingOrder/index'
import position from './modules/position'
import agentOperation from './modules/agentOperation'
import tweet from './modules/tweet'
import rongCloud from './modules/rongCloud'
import companyEntry from './modules/companyEntry'
import activity from './modules/activity'
import satisfaction from './modules/satisfaction'
import jurisdiction from './modules/jurisdiction/index'
import billConfirm from './modules/billConfirm/index'
import talentPlaza from './modules/talentPlaza/index' //设置查看权限
import talentSquare from './modules/talentSquare/index'
const store = new Vuex.Store({
  modules: {
    index,
    receivingOrder,
    position,
    agentOperation,
    tweet,
    rongCloud,
    activity,
    companyEntry,
    satisfaction,
    jurisdiction,
    talentPlaza,
    billConfirm,
    talentSquare,
  },
  //设置查看权限
})

export default store
